import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { SaleItemDetail } from './sale-item-detail';

@JsonObject('model.project.SaleItem')
export class SaleItem extends AbstractModel {

    @JsonProperty(Number, 'amount')
    amount?: number;

    @JsonProperty(String, 'description')
    description?: string;

    @JsonProperty(String, 'id')
    id: string;

    @JsonProperty(String, 'detailType')
    detailType: string;

    @JsonProperty(SaleItemDetail, 'salesItemLineDetail')
    salesItemLineDetail?: SaleItemDetail;
}
